import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** circular arrows, synchronising. Decorative line icon; always pair with a visible text label. */
export function SyncIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M20 12a8 8 0 0 0-14.3-4.7" />
      <path d="M4 12a8 8 0 0 0 14.3 4.7" />
      <path d="M18.5 3.8v3.5H15" />
      <path d="M5.5 20.2v-3.5H9" />
    </IconSvg>
  )
}
